import img1 from "../image1.jpeg";
import img2 from "../image2.jpeg";
export const ImageData = [
  {
    ImageNo: "1",
    ImageName: "",
    ImageSrc: img1,
  },
  {
    ImageNo: "2",
    ImageName: "",
    ImageSrc: img2,
  },
];
